var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [_vm._v("Обрабатывается")]),
      _vm._v(" "),
      _c("UserName", {
        attrs: { id: _vm.isOrderUnderManagerProgress(_vm.orderId, true) },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order_in_manager_progress" },
        [
          _c("time-ago", {
            attrs: {
              refresh: "",
              locale: "ru",
              long: "",
              tooltip: false,
              datetime:
                _vm.$ordersUnderManagerProgress[_vm.orderId][
                  _vm.isOrderUnderManagerProgress(_vm.orderId, true)
                ]?.time,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }